import * as React from 'react';
import { UsernameInput } from '../UsernameInput/UsernameInput';
import { PasswordInput } from '../PasswordInput/PasswordInput';
import Button from '../Button';
import { getForgotEmailUrl, getForgotPasswordUrl } from '../../services/urlService';
import { isNative } from 'ts/services/native/native';
import Checkbox from '../Checkbox';
import styled from 'styled-components';
import { Link } from '@origin-digital/style-guide';

interface LoginViewProps {
  className?: string;
  handleUsernameOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleUsernameOnBlur: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePasswordOnBlur: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePasswordOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleRememberMeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  password: string;
  rememberMe: boolean;
  username: string;
  usernameError: string;
  passwordError: string;
  checkingUser: boolean;
  disableUsernameIcon: boolean;
  isUserNameCheckEnabled: boolean;
}

class LoginStep extends React.Component<LoginViewProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const {
      className,
      handleUsernameOnChange,
      handleUsernameOnBlur,
      handlePasswordOnChange,
      handlePasswordOnBlur,
      handleRememberMeChange,
      password,
      rememberMe,
      username,
      usernameError,
      passwordError,
      checkingUser,
      disableUsernameIcon,
      isUserNameCheckEnabled,
    } = this.props;
    const usernameIdentifier = 'login_username';
    return (
      <div className={className}>
        <div className="LoginStep__field-wrapper">
          <UsernameInput
            id={usernameIdentifier}
            error={usernameError}
            onChange={handleUsernameOnChange}
            onBlur={handleUsernameOnBlur}
            isUserNameCheckEnabled={isUserNameCheckEnabled}
            value={username}
            label="Email address"
            checkingUser={checkingUser}
            disableIcon={disableUsernameIcon}
          />
        </div>
        <div className="LoginStep__field-wrapper">
          <PasswordInput
            label={'Password'}
            autoFocus={!!passwordError}
            value={password}
            onChange={handlePasswordOnChange}
            onBlur={handlePasswordOnBlur}
            error={passwordError}
          />
        </div>
        <Button
          className="LoginStep__button"
          type="submit"
          name="LoginStep__submit-button"
          data-testhook="LoginStep__continue"
          data-id="LoginStep__continue"
        >
          Log in
        </Button>
        <LinksWrapper>
          <GreyedLinks
            componentType="button"
            label="forgot-my-email"
            className="LoginStep__link-wrapper LoginStep__forgot__email"
            data-id="LoginStep__forgot-email"
            href={getForgotEmailUrl()}
          >
            Forgot my email
          </GreyedLinks>
          <GreyedLinks
            componentType="button"
            label="forgot-or-create-password"
            data-id="LoginStep__forgot-password-link"
            className="LoginStep__link-wrapper"
            href={getForgotPasswordUrl()}
          >
            Forgot or create my password
          </GreyedLinks>
        </LinksWrapper>
        {!isNative() && (
          <Checkbox
            checked={rememberMe}
            className="LoginStep__remember-me"
            name="name"
            label="Keep me logged in"
            onChange={handleRememberMeChange}
            data-id="LoginStep__remember-me"
          />
        )}
      </div>
    );
  }
}

const LinksWrapper = styled.div`
  margin: 32px 0 8px 0;
`;

const LoginView = styled(LoginStep)`
  border-top: 1px solid transparent;
  input:-webkit-autofill ~ label {
    transform: translateY(-50%) scale(0.75);
  }

  .LoginStep__field-wrapper {
    margin: 0 0 1px 0;
    overflow: hidden;
  }

  .LoginStep__field-wrapper:first-child {
    margin: 0 0 1px 0;
  }

  .LoginStep__remember-me {
    margin-top: 5px;
    margin-bottom: 34px;
  }
  .LoginStep__link-wrapper {
    display: inline-block;
    margin-left: 32px;
    position: relative;
    left: -32px;
  }
`;

const GreyedLinks = styled(Link)`
  height: 24px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  margin-bottom: 24px;
  color: #505050;
  .LoginStep__forgot__email {
    margin: 0 32px;
  }
`;

export default LoginView;
